// tabs?

const tabs = document?.querySelectorAll('.locations-item');

if (tabs[0]) {
  tabs[0]?.classList.add('active');
  tabs.forEach((item) => {
    const tabNav = item.querySelector('.locations-item__nav');
    const tabBody = item.querySelector('.locations-item__body');
    const tabBodyItemFirst = item.querySelector(
      '.locations-item__body .locations-item__info'
    );

    // console.log(tabBody);

    tabBody.style.maxHeight = `${tabBodyItemFirst.clientHeight}px`;

    item.addEventListener('click', () => {
      if (item.classList.contains('active')) return;
      tabs.forEach((t) => t.classList.remove('active'));
      item.classList.add('active');
    });
  });
}
